<template lang="pug">
  .inputComponent
    .inputTypeOptionContainer(v-if="inputObject.inputType=='checkbox'")
        .row
            .col-3 
                span {{inputObject.name}}
            .col-9 
                .row
                    .col-4(v-for="option in inputObject.options" v-bind:key="option.code") 
                        input(type="checkbox" :name="option.code" v-model="option.selected" @change="$emit('updated')").mr-1
                        span {{option.name}}
                    //- small.text-muted {{inputObject.helpText}}

    .inputTypeTextContainer(v-if="inputObject.inputType=='text'")
        .row
            .col-12
                p {{inputObject.name}}
                input(:name="inputObject.code" v-model="inputObject.inputValue" @change="$emit('updated')").customInput.w-100.px-2
                small.text-muted {{inputObject.helpText}}
        .error {{(inputObject.error) ? inputObject.error : ""}}

    .inputTypeBooleanContainer(v-if="inputObject.inputType=='boolean'")
        .row
            .col-12     
                span {{inputObject.name}} 
                //- Toggle(v-model="inputObject.booleanValue", :name="inputObject.code" @change="$emit('updated')").ml-2
                input(type="checkbox" :name="inputObject.code" v-model="inputObject.booleanValue" @change="$emit('updated')").ml-2
                small.d-block.text-muted {{inputObject.helpText}}

    .inputTypeSelectContainer(v-if="inputObject.inputType=='select'")
        .row
            .col-12 
                p {{inputObject.name}}             
                select(v-model="inputObject.selectedValue" @change="$emit('updated')").customInput.px-2
                    option(v-for="option in inputObject.options" :name="option.code" :value="option.code") {{option.name}}
                small.text-muted {{inputObject.helpText}}
</template>

<script>
import Toggle from './Toggle'
export default {
  name: 'InputComponent',
  components: {
      Toggle
  },
  props:{
    inputObject: Object
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    checkInputValidation(){
        if(this.inputObject.required){
            if("inputValue" in this.inputObject) return (this.inputObject.inputValue != "" && this.inputObject.inputValue != null)
            // if("booleanValue" in this.inputObject) return (this.inputObject.booleanValue != "" && this.inputObject.booleanValue != null)
            if("selectedValue" in this.inputObject) return (this.inputObject.selectedValue != "" && this.inputObject.selectedValue != null)
        }
        return true;
    },
    validate(){
        if(!this.checkInputValidation()){
            this.inputObject.error = "This is a required field";
            this.$forceUpdate(); 
            return false;
        }
        if("error" in this.inputObject) delete this.inputObject.error
        return true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less'); 
   .nav-tabs {
       a {
           color: #4a4a4a;
       }
       .active {
           color: @primary !important;
       }
   }
   .error {
       color: red;
       font-weight: 500;
   }
   span, p {
       font-weight: 400;
   }
</style>
